import { Alert } from '@shared/components';
import { statusLineCopy } from '../../utils/cancellationCopy';
import type { CancellationProgress } from '../../types/cancellation.types';

interface Props {
    progress: CancellationProgress;
}

export function CancellationStatusLine({ progress }: Props) {
    const copy = statusLineCopy(progress);

    return (
        <Alert variant={copy.tone} role="status" className="items-start">
            <div className="space-y-1">
                <p className="font-semibold">{copy.title}</p>
                <p>{copy.detail}</p>
            </div>
        </Alert>
    );
}
